import { FC, MouseEvent } from 'react';
import { IPrimaryButton } from '../../Button.types';

const PrimaryButton: FC<IPrimaryButton> = props => {
  const { onClick, text, classes, htmlButtonType, icon, disabled = false, iconPosition = 'right' } = props;

  const handleClick = (event: MouseEvent<EventTarget>) => {
    event.preventDefault();
    event.stopPropagation();

    onClick(event);
  };

  return (
    <button
      className={`${classes?.container} disabled:bg-platinum disabled:cursor-not-allowed`}
      disabled={disabled}
      onClick={handleClick}
      data-id={props['data-id'] ?? ''}
      type={htmlButtonType ?? 'button'}
    >
      {iconPosition === 'left' ? icon : null}
      <span className={classes?.text}>{text}</span>
      {iconPosition === 'right' ? icon : null}
    </button>
  );
};

export default PrimaryButton;
